import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { P360Card } from 'legacy/lut/components/widgets/public/partner360/p360Card'
import { FC } from 'react'

import { Translation } from 'cng-common/features/translations'
import { QualityDonut, Tag } from 'partner360/components/qualityIndicator'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { TRANSLATION_KEYS } from '../../configs/translations'
import { useFinancialPlanQuality } from '../../model/useFinancialPlanQuality'
import { FinancialPlanQualityContent } from '../financialPlanQualityContent/FinancialPlanQualityContent'
import { FinancialPlanRequirements } from '../financialPlanRequirements/FinancialPlanRequirements'

import { FinancialPlanQualitySkeleton } from './components/financialPlanQualitySkeleton/FinancialPlanQualitySkeleton'

import styles from './FinancialPlanQuality.module.scss'

interface IFinancialPlanQualityProps {
  partnerId: string
  fYear: number
  programType: ProgramTypes
  isGlobal?: boolean
  onCategoryPlanningClick?: () => void
}

export const FinancialPlanQuality: FC<IFinancialPlanQualityProps> = ({
  partnerId,
  fYear,
  programType,
  isGlobal = false,
  onCategoryPlanningClick,
}) => {
  const { currency, hasPlan, isFetching, metric, quality } = useFinancialPlanQuality({
    partnerId,
    fYear,
    programType,
    isGlobal,
  })

  if (isFetching) {
    return <FinancialPlanQualitySkeleton />
  }

  if (!hasPlan) {
    return (
      <P360Card className={styles.root}>
        <FinancialPlanRequirements />{' '}
      </P360Card>
    )
  }

  return (
    <P360Card className={styles.root}>
      <div className={styles.content}>
        <div className={styles.chart}>
          <div className={styles.title}>
            <Translation
              text={TRANSLATION_KEYS.quality.title}
              replaceParams={[
                {
                  key: '{metric}',
                  value: metric === ActualsValueTypes.Ndp ? 'NDP' : metric,
                },
                { key: '{currency}', value: currency },
              ]}
            />
          </div>

          <div className={styles.subtitle}>
            <Translation text={TRANSLATION_KEYS.quality.subtitle} />
          </div>

          <div className={styles.donut}>
            <QualityDonut score={quality.overall.score} band={quality.overall.band} />
            <Tag variant={quality.overall.band} />
          </div>
        </div>

        <FinancialPlanQualityContent
          quality={quality}
          onCategoryPlanningClick={onCategoryPlanningClick}
        />
      </div>
    </P360Card>
  )
}
